import { render, staticRenderFns } from "./cuotiBen.vue?vue&type=template&id=2419b474&scoped=true"
import script from "./cuotiBen.vue?vue&type=script&lang=js"
export * from "./cuotiBen.vue?vue&type=script&lang=js"
import style0 from "./cuotiBen.vue?vue&type=style&index=0&id=2419b474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2419b474",
  null
  
)

export default component.exports